import { useMemo } from 'react'

import type { LiveSite, LiveSitesObject } from '../types/liveSite'
import urlRepository from '../utils/constants/urlRepository'
import { useFetch } from './useAPI'

export interface UseSitesResult {
    sites: LiveSite[]
    /** channel code (lowercased) → display name. First-seen siteName wins. */
    byChannel: Record<string, string>
    isLoading: boolean
    error?: Error
}

const EMPTY_SITES: LiveSite[] = []

const useSites = (): UseSitesResult => {
    const { data, isLoading, fetchError } = useFetch<LiveSitesObject>(
        urlRepository.gatewayGetSites,
        undefined,
        undefined,
        false,
        undefined,
        true
    )

    const sites = data?.sites ?? EMPTY_SITES

    const byChannel = useMemo(() => {
        const map: Record<string, string> = {}
        for (const s of sites) {
            if (!s.channel) continue
            const key = s.channel.toLowerCase()
            if (!map[key]) {
                map[key] = s.siteName ?? s.name ?? s.channel
            }
        }
        return map
    }, [sites])

    return { sites, byChannel, isLoading, error: fetchError }
}

export default useSites
